import { Grid } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import ArticleSection from './articleSection';
import StockChart from './StockChart';
import styles from './stockStyles';

const RightSidebar = ({ stockPageState, setStockPageState }) => {
  const { isMobile, articles } = useSelector((state) => state.appReducer);
  return (
    <Grid item xl={3} lg={3} sm={12} xs={12} md={3} style={{ height: '100%' }}>
      <div
        style={{
          height: 'calc(100%)',
          paddingTop: '25px',
          paddingBottom: '30px',
          boxSizing: 'border-box',
          background: '#D3D3D3',
          marginTop: isMobile ? '10px' : '0px',
        }}
      >
        <StockChart symbol={stockPageState.symbol} />
        <div style={styles.articlesTitleFixed}></div>
        <ArticleSection articles={articles} />
      </div>
    </Grid>
  );
};

export default RightSidebar;



// WEBPACK FOOTER //
// ./src/Pages/Stock/RightSidebar.jsx